<template>
  <div class="my-samples">
    <h2>{{mySamplesText}}</h2>
    <TanninDisplayPage mode="user" :userMode="userMode" />
  </div>
</template>

<script>
import TanninDisplayPage from '../components/TanninDisplayPage';

export default {
  name: 'MySamples',
  components: {
    TanninDisplayPage,
  },
  mounted() {
    this.$store.dispatch('getLevels');
    this.$store.dispatch('getYears');
    this.$store.dispatch('getVarieties');
    this.$store.dispatch('getLocations');
    this.$store.dispatch('getLocationsAll');
    this.$store.dispatch('getSamplesPublic');
    this.$store.dispatch('getSamplesByUser', {
      user_id: this.$auth.user().id,
    });
  },
  computed: {
    mySamplesText() {
      const roles = this.$auth.user().roles;
      let text = '';
      if (roles.includes('winemaker-multi')) {
        text = 'My Samples - Ripening';
      } else {
        text = 'My Sample - Harvest';
      }
      return text;
    },
    userMode() {
      const roles = this.$auth.user().roles;
      if (roles.includes('winemaker-multi')) {
        return 'ripening';
      }
      return 'harvest';
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/MySamples.vue